/* unplugin-vue-components disabled */import { render } from "./kjdate.vue?vue&type=template&id=8d621976&scoped=true"
import script from "./kjdate.vue?vue&type=script&lang=js"
export * from "./kjdate.vue?vue&type=script&lang=js"

import "./kjdate.vue?vue&type=style&index=0&id=8d621976&scoped=true&lang=css"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d621976"]])

export default __exports__